import React from "react";
import styled from "styled-components";
import { sm, xs } from "../BreakPoints";
import SearchIcon from "../Images/search-icon.svg";

const Container = styled.div`
  width: 14.5rem;
  min-width: 6.2rem;
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
  background-color: var(--ice-blue);
  height: 1.9rem;
  box-sizing: border-box;
  border-radius: 0.4rem;
  border: 1px solid var(--line-mid);
  padding: 0.12rem 0.55rem;
  color: var(--text-muted);
  &:hover {
    background-color: var(--surface-white);
  }
  ${sm({
    width: "10rem",
  })}
  ${xs({
    width: "9rem",
  })}
`;
const Input = styled.input`
  box-sizing: content-box;
  font-size: 0.85rem;
  border: none;
  color: var(--deep-navy);
  background-color: transparent;
  outline: none;
  height: 0.95rem;
  overflow: hidden;
  width: 100%;
  &::placeholder {
    color: var(--slate);
  }
  &:focus {
    font-weight: 500;
  }
`;

const Icon = styled.img`
  width: 18px;
  height: 18px;
  opacity: 0.72;
  ${xs({
    width: "16px",
    height: "16px",
  })}
`;

const SearchBar = (props) => {
  const { searchString, setSearchString, placeholder } = props;
  return (
    <Container>
      <Icon src={SearchIcon} />
      <Input
        placeholder={placeholder || "Search boards"}
        value={searchString}
        onChange={(e) => setSearchString(e.target.value)}
      />
    </Container>
  );
};

export default SearchBar;
